import { WebhookSubscriptionEventEnum } from '../types/webhook-settings-interface'

export const eventTypeTitleLocoKeys: Record<WebhookSubscriptionEventEnum, string> = {
  [WebhookSubscriptionEventEnum.ContactCreated]:
    'dashboard.user_settings.webhooks.event_title.contact_created',
  [WebhookSubscriptionEventEnum.ContactTagAdded]:
    'dashboard.user_settings.webhooks.event_title.contact_tag_added',
  [WebhookSubscriptionEventEnum.ContactTagRemoved]:
    'dashboard.user_settings.webhooks.event_title.contact_tag_removed',
  [WebhookSubscriptionEventEnum.ContactOptIn]:
    'dashboard.user_settings.webhooks.event_title.contact_opt_in',
  [WebhookSubscriptionEventEnum.SaleNew]: 'dashboard.user_settings.webhooks.event_title.sale_new',
  [WebhookSubscriptionEventEnum.SaleCanceled]:
    'dashboard.user_settings.webhooks.event_title.sale_cancelled',
}

export const eventTypeDescriptionLocoKeys: Record<WebhookSubscriptionEventEnum, string> = {
  [WebhookSubscriptionEventEnum.ContactCreated]:
    'dashboard.user_settings.webhooks.event_description.contact_created',
  [WebhookSubscriptionEventEnum.ContactTagAdded]:
    'dashboard.user_settings.webhooks.event_description.contact_tag_added',
  [WebhookSubscriptionEventEnum.ContactTagRemoved]:
    'dashboard.user_settings.webhooks.event_description.contact_tag_removed',
  [WebhookSubscriptionEventEnum.ContactOptIn]:
    'dashboard.user_settings.webhooks.event_description.contact_opt_in',
  [WebhookSubscriptionEventEnum.SaleNew]:
    'dashboard.user_settings.webhooks.event_description.sale_new',
  [WebhookSubscriptionEventEnum.SaleCanceled]:
    'dashboard.user_settings.webhooks.event_description.sale_cancelled',
}
